function makeSlug(aString)
{
    return aString.toLowerCase().replace(' ', '-');
}

module.exports.makeSlug = makeSlug;